<template>
  <div :class="wrapperClass">
    <form @submit.prevent="getLogin">
      <div class="form-group fieldsErrorMessage" v-html="AUTH_ERROR"></div>
      <div class="form-group text-center">
        <img :src="`${baseurl}/media/logo.png`" width="80" height="40" alt />
      </div>
      <div class="form-group">
        <input
          type="text"
          placeholder="логин"
          v-model="login"
          @keypress="errorEmpty"
          class="form-control shadow-none"
        />
        <small
          v-if="
            ($v.login.$dirty && !$v.login.required) ||
              ($v.login.$dirty && !$v.login.minLength)
          "
          class="form-text text-muted"
          >введите логин</small
        >
        <div v-else />
      </div>
      <div class="form-group">
        <input
          type="password"
          placeholder="пароль"
          autocomplete="false"
          v-model="password"
          @keypress="errorEmpty"
          class="form-control shadow-none"
        />
        <small
          v-if="
            ($v.password.$dirty && !$v.password.required) ||
              ($v.password.$dirty && !$v.password.minLength)
          "
          class="form-text text-muted"
          >введите пароль</small
        >
        <div v-else />
      </div>
      <button class="btn btn-primary btn-block">
        войти
      </button>
    </form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";
import u from "@/constants/";
export default {
  name: "Login",
  data: () => ({
    login: "",
    password: "",
    error: null,
    baseurl: u.url
  }),
  validations: {
    login: { required, minLength: minLength(3) },
    password: { required, minLength: minLength(3) }
  },
  computed: {
    ...mapGetters(["AUTH_ERROR", "CLOSESITE", "GET_PATH_TO", "USER_INFO"]),
    wrapperClass() {
      if (this.CLOSESITE) {
        return "auth-form-wrapper-close";
      } else {
        return "auth-form-wrapper";
      }
    }
  },
  methods: {
    ...mapActions(["LOGIN"]),
    getLogin() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      const login = this.login;
      const password = this.password;
      this.LOGIN({ login, password }).then(() => {
        //console.log(this.$route.path);
        //this.$route.path === "/login"
        //  ? this.$router.push("/home")
        //  : this.$router.push(this.GET_PATH_TO);
        if (this.USER_INFO.status === "tehnik") {
          this.$router.push("/kabinet/stats");
        } else {
          this.$router.push(this.GET_PATH_TO);
        }
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      });
    },
    errorEmpty() {
      if (this.error) {
        this.error = null;
      }
    }
  }
};
</script>
<style scoped>
.auth-form-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.auth-form-wrapper-close {
  display: flex;
  justify-content: center;
  height: 100vh;
}

.fieldsErrorMessage {
  text-align: center;
  color: red;
}
</style>
